import React from "react";
import { Wrapper } from './Loader.style';

const Loader = () => {
  return <Wrapper />
}

export default Loader
